var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgNetbanking = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 17,
  viewBox: "0 0 25 17",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.78625 0.100555C2.12461 0.100555 0.777588 1.44758 0.777588 3.10921V13.6395C0.777588 15.3012 2.12461 16.6482 3.78625 16.6482H21.8382C23.4998 16.6482 24.8469 15.3012 24.8469 13.6395V3.10921C24.8469 1.44758 23.4998 0.100555 21.8382 0.100555H3.78625ZM4.53841 3.86138H10.5557V5.36571H4.53841V3.86138ZM4.53841 12.1352H7.54707V13.6395H4.53841V12.1352ZM12.0601 12.1352V13.6395H9.0514V12.1352H12.0601ZM13.5644 12.1352H16.573V13.6395H13.5644V12.1352ZM18.0774 12.1352H21.086V13.6395H18.0774V12.1352Z",
  fill: "white"
})));
export { SvgNetbanking as ReactComponent };
export default __webpack_public_path__ + "assets/icons/netbanking.014f3b.svg";